"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DynamicFields = void 0;
Object.defineProperty(exports, "availableComponents", {
  enumerable: true,
  get: function () {
    return _DynamicComponents.availableComponents;
  }
});
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactHookForm = require("react-hook-form");
var _DynamicComponents = require("./DynamicComponents");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const DynamicFields = _ref => {
  let {
    inputType,
    fieldName,
    maxHeight,
    maxListHeight,
    watching,
    expecting,
    defaultValue,
    label,
    options = [],
    config = {},
    otherOptions = {},
    controlError,
    UI,
    handler,
    handleDataUpdates
  } = _ref;
  const {
    register,
    control
  } = (0, _reactHookForm.useFormContext)({
    mode: 'all'
  });
  switch (inputType) {
    case 'text':
    case 'number':
    case 'date':
    case 'email':
    case 'password':
      return /*#__PURE__*/_react.default.createElement("label", {
        className: "label"
      }, label || /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "\xA0"), /*#__PURE__*/_react.default.createElement("div", {
        className: UI.icon && `control has-icons-${UI.iconLocation} `
      }, /*#__PURE__*/_react.default.createElement("input", _extends({
        className: `input ${controlError}`,
        id: fieldName,
        name: fieldName,
        type: inputType
      }, register(fieldName, config), {
        defaultValue: defaultValue
      }, otherOptions)), UI.icon && /*#__PURE__*/_react.default.createElement("span", {
        className: `icon is-${UI.iconLocation}`
      }, /*#__PURE__*/_react.default.createElement("i", {
        className: "material-icons"
      }, UI.icon))));
    case 'select':
      return /*#__PURE__*/_react.default.createElement("label", {
        className: "label"
      }, label || /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "\xA0"), /*#__PURE__*/_react.default.createElement("div", {
        className: UI.icon && `control has-icons-${UI.iconLocation} `
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: `select ${controlError}`,
        style: {
          width: '100%'
        }
      }, /*#__PURE__*/_react.default.createElement("select", _extends({
        style: {
          width: '100%'
        },
        className: `select ${controlError}`
      }, register(fieldName, config), {
        defaultValue: defaultValue,
        name: fieldName,
        id: fieldName
      }), options.map((option, index) => /*#__PURE__*/_react.default.createElement("option", {
        key: index,
        value: option.value
      }, option.label)))), UI.icon && /*#__PURE__*/_react.default.createElement("span", {
        className: `icon is-${UI.iconLocation}`
      }, /*#__PURE__*/_react.default.createElement("i", {
        className: "material-icons"
      }, UI.icon))));
    case 'textarea':
      return /*#__PURE__*/_react.default.createElement("label", {
        className: "label"
      }, label || /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "\xA0"), /*#__PURE__*/_react.default.createElement("div", {
        className: UI.icon && `control has-icons-${UI.iconLocation} `
      }, /*#__PURE__*/_react.default.createElement("textarea", _extends({
        className: `textarea is-medium  ${controlError}`,
        id: fieldName,
        name: fieldName,
        type: "text"
      }, register(fieldName, config), {
        defaultValue: defaultValue
      })), UI.icon && /*#__PURE__*/_react.default.createElement("span", {
        className: `icon is-${UI.iconLocation}`
      }, /*#__PURE__*/_react.default.createElement("i", {
        className: "material-icons"
      }, UI.icon))));
    case 'checkbox':
      return /*#__PURE__*/_react.default.createElement("label", {
        className: "checkbox"
      }, /*#__PURE__*/_react.default.createElement("input", _extends({
        className: "checkbox",
        id: fieldName,
        name: fieldName,
        type: inputType
      }, register(fieldName, config))), /*#__PURE__*/_react.default.createElement("span", null, label));
    case 'radio':
      return /*#__PURE__*/_react.default.createElement("label", {
        className: "radio"
      }, /*#__PURE__*/_react.default.createElement("input", _extends({
        className: "radio",
        name: fieldName,
        type: inputType
      }, register(fieldName, config), {
        defaultValue: defaultValue
      })), /*#__PURE__*/_react.default.createElement("span", null, label));
    case 'Select':
      return /*#__PURE__*/_react.default.createElement(_reactHookForm.Controller, {
        name: fieldName,
        defaultValue: defaultValue,
        watching: watching,
        control: control,
        rules: config,
        handler: handler,
        render: _ref2 => {
          let {
            field: {
              onChange,
              value
            }
          } = _ref2;
          return /*#__PURE__*/_react.default.createElement(_DynamicComponents.Select, _extends({
            iconLeft: UI.iconLocation === 'left' ? UI.icon : undefined,
            iconRight: UI.iconLocation === 'right' ? UI.icon : undefined,
            name: fieldName,
            maxHeight: maxHeight,
            maxListHeight: maxListHeight,
            label: label
          }, register(fieldName), otherOptions, {
            options: options,
            controlError: controlError,
            defaultValue: typeof defaultValue?.value !== 'undefined' ? defaultValue.value : defaultValue,
            onChange: data => {
              let changeData = null;
              if (Array.isArray(data)) {
                changeData = data ? data.map(item => handler ? item[handler] : item.value) : null;
              } else {
                changeData = handler && data ? data[handler] : data.value;
              }
              onChange(changeData);
              handleDataUpdates(changeData);
            },
            disableDefaultValidation: true
          }));
        }
      });
    case 'ToggleButtons':
      return /*#__PURE__*/_react.default.createElement(_reactHookForm.Controller, {
        name: fieldName,
        defaultValue: defaultValue,
        watching: watching,
        control: control,
        rules: config,
        handler: handler,
        render: _ref3 => {
          let {
            field: {
              onChange
            }
          } = _ref3;
          return /*#__PURE__*/_react.default.createElement(_DynamicComponents.ToggleButtons, _extends({
            name: fieldName,
            label: label
          }, register(fieldName), otherOptions, {
            options: options,
            controlError: controlError,
            defaultValue: defaultValue,
            onChange: data => {
              onChange(data);
              handleDataUpdates(data);
            },
            disableDefaultValidation: true
          }));
        }
      });
    case 'Checkbox':
      return /*#__PURE__*/_react.default.createElement(_DynamicComponents.Checkbox, _extends({
        name: fieldName,
        label: label || ' ',
        controlError: controlError
      }, register(fieldName, config), otherOptions, {
        checked: defaultValue,
        onChange: data => handleDataUpdates(data),
        disableDefaultValidation: true
      }));
    case 'CheckboxGroup':
      return /*#__PURE__*/_react.default.createElement(_reactHookForm.Controller, {
        name: fieldName,
        watching: watching,
        control: control,
        rules: config,
        handler: handler,
        defaultValue: defaultValue,
        render: _ref4 => {
          let {
            field: {
              onChange
            }
          } = _ref4;
          return /*#__PURE__*/_react.default.createElement(_DynamicComponents.CheckboxGroup, _extends({
            options: options,
            label: label || ' '
          }, register(fieldName), otherOptions, {
            defaultValue: defaultValue,
            onChange: data => {
              let changeData = null;
              if (Array.isArray(data)) {
                changeData = data ? data.map(item => handler ? item[handler] : item.value) : null;
              } else {
                changeData = handler && data ? data[handler] : data.value;
              }
              onChange(changeData);
              handleDataUpdates(changeData);
            },
            disableDefaultValidation: true
          }));
        }
      });
    case 'RadioButton':
      return /*#__PURE__*/_react.default.createElement(_DynamicComponents.RadioButton, _extends({
        name: fieldName,
        label: label || ' '
      }, register(fieldName, config), otherOptions, {
        value: defaultValue,
        onChange: data => handleDataUpdates(data),
        disableDefaultValidation: true
      }));
    case 'RadioButtonGroup':
      return /*#__PURE__*/_react.default.createElement(_reactHookForm.Controller, {
        name: fieldName,
        watching: watching,
        control: control,
        rules: config,
        handler: handler,
        defaultValue: typeof defaultValue?.value !== 'undefined' ? defaultValue.value : defaultValue,
        render: _ref5 => {
          let {
            field: {
              onChange
            }
          } = _ref5;
          return /*#__PURE__*/_react.default.createElement(_DynamicComponents.RadioButtonGroup, _extends({
            label: label || ' ',
            options: options
          }, register(fieldName), otherOptions, {
            defaultValue: defaultValue,
            onChange: data => {
              const changeData = handler && data ? data[handler] : data.value;
              onChange(changeData);
              handleDataUpdates(changeData);
            },
            disableDefaultValidation: true
          }));
        }
      });
    case 'DateInput':
      return /*#__PURE__*/_react.default.createElement(_reactHookForm.Controller, {
        name: fieldName,
        watching: watching,
        control: control,
        rules: config,
        render: _ref6 => {
          let {
            field: {
              onChange
            }
          } = _ref6;
          return /*#__PURE__*/_react.default.createElement(_DynamicComponents.DateInput, _extends({
            label: label,
            defaultValue: defaultValue,
            controlError: controlError,
            UI: UI
          }, register(fieldName), otherOptions, {
            onDateChange: data => {
              onChange(data);
              handleDataUpdates(data);
            },
            disableDefaultValidation: true
          }));
        }
      });
    case 'DateInputRange':
      return /*#__PURE__*/_react.default.createElement(_reactHookForm.Controller, {
        name: fieldName,
        watching: watching,
        control: control,
        rules: config,
        render: _ref7 => {
          let {
            field: {
              onChange
            }
          } = _ref7;
          return /*#__PURE__*/_react.default.createElement(_DynamicComponents.DateInputRange, _extends({
            name: fieldName,
            label: label,
            controlError: controlError,
            UI: UI,
            defaultValue: defaultValue
          }, register(fieldName), otherOptions, {
            onDateChange: data => {
              onChange(data);
              handleDataUpdates(data);
            },
            dateFormat: otherOptions?.dateFormat,
            disableDefaultValidation: true
          }));
        }
      });
    case 'TextInput':
      return /*#__PURE__*/_react.default.createElement(_reactHookForm.Controller, {
        name: fieldName,
        watching: watching,
        expecting: expecting,
        control: control,
        rules: config,
        render: _ref8 => {
          let {
            field: {
              onChange,
              onBlur
            }
          } = _ref8;
          return /*#__PURE__*/_react.default.createElement(_DynamicComponents.TextInput, _extends({
            id: fieldName
          }, register(fieldName), otherOptions, {
            label: label || ' ',
            onChange: onChange,
            onBlur: onBlur,
            controlError: controlError,
            value: defaultValue,
            iconLeft: UI.iconLocation === 'left' ? UI.icon : undefined,
            iconRight: UI.iconLocation === 'right' ? UI.icon : undefined,
            disableDefaultValidation: true
          }));
        }
      });
    case 'Paragraph':
      return /*#__PURE__*/_react.default.createElement(_DynamicComponents.Paragraph, _extends({
        text: defaultValue
      }, otherOptions));
    default:
      return /*#__PURE__*/_react.default.createElement(_react.Fragment, null);
  }
};
exports.DynamicFields = DynamicFields;
DynamicFields.propTypes = {
  inputType: _propTypes.default.string.isRequired,
  fieldName: _propTypes.default.string.isRequired,
  watching: _propTypes.default.string,
  expecting: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.bool, _propTypes.default.array, _propTypes.default.object]),
  defaultValue: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.bool, _propTypes.default.array, _propTypes.default.object]),
  label: _propTypes.default.string,
  maxHeight: _propTypes.default.number,
  maxListHeight: _propTypes.default.number,
  options: _propTypes.default.array,
  config: _propTypes.default.object,
  otherOptions: _propTypes.default.object,
  controlError: _propTypes.default.string,
  handleDataUpdates: _propTypes.default.func,
  UI: _propTypes.default.object,
  handler: _propTypes.default.string
};
//# sourceMappingURL=DynamicFields.js.map